import { render, staticRenderFns } from "./ModalWrapper.vue?vue&type=template&id=2b3fca8f&scoped=true"
import script from "./ModalWrapper.vue?vue&type=script&lang=js"
export * from "./ModalWrapper.vue?vue&type=script&lang=js"
import style0 from "./ModalWrapper.vue?vue&type=style&index=0&id=2b3fca8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3fca8f",
  null
  
)

export default component.exports